import constants from './BaseConstants';
export default {
  MERCHANT_URL: constants.BASE_URL + 'admin/merchants/',
  MERCHANT_OPENING_HOURS_URL: constants.BASE_URL + 'admin/merchants/opening_hours',
  MERCHANT_SET_USER: 'MERCHANT_SET_USER',
  MERCHANT_SET_ADDRESS: 'MERCHANT_SET_ADDRESS',
  MERCHANT_GET_TYPES: 'MERCHANT_GET_TYPES',
  SET_PROFILE_FORM: 'SET_PROFILE_FORM',
  SET_PROFILE_FIELD_ADDRESS: 'SET_PROFILE_FIELD_ADDRESS',
  SET_OPEN_HOURS: 'SET_OPEN_HOURS',
  MERCHANT_UPDATE_USER: 'MERCHANT_UPDATE_USER'
}



/** WEBPACK FOOTER **
 ** ./src/constants/MerchantConstants.js
 **/